import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("attributes.managment.attribute_master_title"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c("template", { slot: "description" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("attributes.managment.attribute_master_subtitle")
                ) +
                " "
            ),
          ]),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog(_vm.DIALOG_ADD)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("attributes.managment.button.create")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              VCard,
              { staticClass: "without-filter" },
              [
                _c(VDataTable, {
                  staticClass: "text-center table-inca",
                  attrs: {
                    headers: _vm.headers,
                    "items-per-page": _vm.pagination.limit,
                    items: _vm.Items,
                    page: _vm.pagination.current,
                    "sticky-header": true,
                    "hide-default-footer": "",
                    hover: "",
                    responsive: "",
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.name",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _vm.idioma == "es"
                            ? _c("div", [_vm._v(_vm._s(item.name_es))])
                            : _c("div", [_vm._v(_vm._s(item.name_en))]),
                        ]
                      },
                    },
                    {
                      key: "item.description",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _vm.idioma == "es"
                            ? _c("div", [_vm._v(_vm._s(item.description_es))])
                            : _c("div", [_vm._v(_vm._s(item.description_en))]),
                        ]
                      },
                    },
                    {
                      key: "item.multiple",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("div", [
                            _c("b", [_vm._v("Project: ")]),
                            _vm._v(_vm._s(item.attribute_project_name)),
                          ]),
                          _c("div", [
                            _c("b", [_vm._v("Dataset: ")]),
                            _vm._v(_vm._s(item.attribute_scheme_name)),
                          ]),
                          _c("div", [
                            _c("b", [_vm._v("Table: ")]),
                            _vm._v(_vm._s(item.attribute_object_name)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openDialogItem(
                                                      item,
                                                      _vm.DIALOG_EDIT
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-edit")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Editar")])]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openDialogItem(
                                                      item,
                                                      _vm.DIALOG_BLACK_LIST
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-clipboard-list-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Denegar")])]
                          ),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          VBtn,
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openDialogItem(
                                                      item,
                                                      _vm.DIALOG_SYNC
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-sync")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v("Sincronización")])]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD,
        attrs: {
          title: _vm.$t("attributes.managment.modal_add_attribute_master"),
          "show-buttons": true,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("add-attribute-master", {
                  ref: "addAttributeMaster",
                  on: {
                    close: function ($event) {
                      return _vm.onCloseDialog(_vm.DIALOG_ADD)
                    },
                    SubmitMaster: _vm.onSubmitAddMaster,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.addAttributeMaster.onSubmit($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("frases.register")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_EDIT,
        attrs: {
          title: _vm.$t("attributes.managment.modal_edit_attribute_master"),
          "show-buttons": true,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("edit-attribute-master", {
                  ref: "editAttributeMaster",
                  attrs: { item: _vm.elemento },
                  on: {
                    close: function ($event) {
                      return _vm.onCloseDialog(_vm.DIALOG_EDIT)
                    },
                    SubmitEditMaster: _vm.onSubmitEditMaster,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.editAttributeMaster.onSubmit($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("frases.update")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_BLACK_LIST,
        attrs: {
          title:
            _vm.elemento.name_es +
            " - " +
            _vm.$t("attributes.managment.label.selected_list"),
          "show-buttons": false,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("edit-black-list-attributes", {
                  attrs: { item: _vm.elemento },
                  on: {
                    close: function ($event) {
                      return _vm.onCloseDialog(_vm.DIALOG_BLACK_LIST)
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_SYNC,
        attrs: {
          title: "Sincronización de atributos",
          text: "¿Desea continuar con la sincronización de atributos?",
        },
        on: { onConfirm: _vm.handleConfirmSync },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }